<app-view #view [code]="'organizations.edit'" [model]="organization" (onEvent)="onEvent($event)"></app-view>